import { adminNotificationAnalyticsQueryKeys as e } from "./adminNotificationAnalyticsQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminNotificationsApi as n } from "@maat/api-notifications";
//#region src/notifications/admin/useAdminNotificationAnalyticsTimeseriesQuery.ts
var r = (r, i) => t({
	queryKey: e.timeseries(r, i),
	queryFn: () => n.getAnalyticsTimeseries(r, i)
});
//#endregion
export { r as useAdminNotificationAnalyticsTimeseriesQuery };
